import React, { useState } from "react";
import axios from "axios";

const JoinModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    city: "",
    linkedin: "",
    status: "",
    organization: "",
    interested: "",
    joinWhatsapp: "",
    whatsappNumber: "",
  });

  const [message, setMessage] = useState("");

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const {
      firstName,
      lastName,
      gender,
      city,
      linkedin,
      status,
      organization,
      interested,
      joinWhatsapp,
      whatsappNumber,
    } = formData;

    if (!firstName || !lastName) return "First & Last name are required";
    if (!gender) return "Gender is required";
    if (!city) return "City is required";
    if (!status) return "Status is required";
    if (!organization) return "Organization is required";
    if (!interested) return "Please select interest option";
    if (!joinWhatsapp) return "Please select WhatsApp option";

    const linkedinRegex = /^https?:\/\/(www\.)?linkedin\.com\/.+$/;
    if (!linkedinRegex.test(linkedin)) return "Invalid LinkedIn profile URL";

    if (joinWhatsapp === "Yes") {
      const phoneRegex = /^[0-9]{10,15}$/;
      if (!phoneRegex.test(whatsappNumber)) {
        return "Valid WhatsApp number is required";
      }
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validateForm();
    if (error) {
      setMessage(error);
      return;
    }

    try {
      await axios.post("http://localhost:5000/api/joinus", formData);
      setMessage("✅ Successfully joined!");
      setFormData({
        firstName: "",
        lastName: "",
        gender: "",
        city: "",
        linkedin: "",
        status: "",
        organization: "",
        interested: "",
        joinWhatsapp: "",
        whatsappNumber: "",
      });

      onClose();
    } catch (err) {
      setMessage("❌ Submission failed");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Join Us</h2>

        <form onSubmit={handleSubmit} className="join-form">

        <div className="form-row">
            <label>First Name *</label>
            <input
            name="firstName"
            placeholder="Enter first name"
            value={formData.firstName}
            onChange={handleChange}
            required
            />
        </div>

        <div className="form-row">
            <label>Last Name *</label>
            <input
            name="lastName"
            placeholder="Enter last name"
            value={formData.lastName}
            onChange={handleChange}
            required
            />
        </div>

        <div className="form-row">
            <label>Gender *</label>
            <select name="gender" value={formData.gender} onChange={handleChange} required>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Prefer not to say">Prefer not to say</option>
            </select>
        </div>

        <div className="form-row">
            <label>Current City of Residence *</label>
            <input
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
            />
        </div>

        <div className="form-row">
            <label>LinkedIn Profile URL *</label>
            <input
            name="linkedin"
            placeholder="https://linkedin.com/in/username"
            value={formData.linkedin}
            onChange={handleChange}
            required
            />
        </div>

        <div className="form-row">
        <label>Educational / Professional Status *</label>
        <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            required
        >
            <option value="">Select status</option>
            <option value="Cybersecurity Professional">Cybersecurity Professional</option>
            <option value="Faculty/Trainer - Cybersecurity">Faculty / Trainer (Cybersecurity)</option>
            <option value="Non-Cybersecurity Professional">Non-Cybersecurity Professional</option>
            <option value="Student - Cybersecurity Enthusiast">Student (Cybersecurity Enthusiast)</option>
        </select>
        </div>


        <div className="form-row">
            <label>Company / College Name *</label>
            <input
            name="organization"
            placeholder="Organization name"
            value={formData.organization}
            onChange={handleChange}
            required
            />
        </div>

        <div className="form-row">
            <label>Interested in contributing? *</label>
            <select
            name="interested"
            value={formData.interested}
            onChange={handleChange}
            required
            >
            <option value="">Select option</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            </select>
        </div>

        <div className="form-row">
            <label>Join WhatsApp Group? *</label>
            <select
            name="joinWhatsapp"
            value={formData.joinWhatsapp}
            onChange={handleChange}
            required
            >
            <option value="">Select option</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            </select>
        </div>

        {formData.joinWhatsapp === "Yes" && (
            <div className="form-row full-width">
            <label>WhatsApp Number *</label>
            <input
                name="whatsappNumber"
                placeholder="Enter WhatsApp number"
                value={formData.whatsappNumber}
                onChange={handleChange}
                required
            />
            </div>
        )}

        <p className="info-text">
            Feel free to reach out: <b>ngcyberwomen@gmail.com</b>
        </p>

        <div className="button-row">
            <button type="submit" className="submit-btn">Submit</button>
            <button type="button" className="close-btn" onClick={onClose}>Close</button>
        </div>

        </form>


        {message && <p>{message}</p>}
      </div>
      <style>{`/* Overlay */
        .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        padding: 16px;
        }

        /* Modal container */
        .modal {
        background: linear-gradient(135deg, #0d1440, #151f6d);
        color: #fff;
        width: 100%;
        max-width: 520px;
        max-height: 90vh;
        border-radius: 16px;
        padding: 24px;
        overflow-y: auto; /* ✅ vertical scroll */
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
        }

        /* Title */
        .modal h2 {
        text-align: center;
        margin-bottom: 20px;
        }

        /* Form layout (VERTICAL) */
        .join-form {
        display: flex;
        flex-direction: column;
        gap: 14px;
        }

        /* Each field */
        .form-row {
        display: flex;
        flex-direction: column;
        }

        /* Labels */
        .form-row label {
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 6px;
        }

        /* Inputs & selects */
        .form-row input,
        .form-row select {
        width: 100%;
        padding: 10px 12px;
        font-size: 14px;
        border-radius: 6px;
        border: 1px solid #ccc;
        }

        /* Info text */
        .info-text {
        font-size: 12px;
        margin-top: 8px;
        text-align: center;
        }

        /* Buttons */
        .button-row {
        display: flex;
        justify-content: center;
        gap: 12px;
        margin-top: 16px;
        }

        .submit-btn {
        background-color: #f4b400;
        color: #000;
        padding: 10px 20px;
        border-radius: 6px;
        border: none;
        cursor: pointer;
        }

        .close-btn {
        background-color: #ddd;
        padding: 10px 20px;
        border-radius: 6px;
        border: none;
        cursor: pointer;
        }

        /* Message */
        .modal > p {
        margin-top: 10px;
        text-align: center;
        }

        /* Mobile safety */
        @media (max-width: 480px) {
        .modal {
            padding: 20px;
        }
        }
`}</style>
    </div>
  );
};


export default JoinModal;
